import { Box, Button, Theme, Typography } from '@mui/material'
import { useHistory } from 'react-router-dom';
import { navigationData } from '../types';

export default function GoalCalculatorCard({ data }: { data: any }): JSX.Element {
    const history = useHistory();
    const { pathname, state } = history.location
    const { clientCode = '' } = state as navigationData

    const goToGoalCalculator = () => {
        history.push(`${pathname}/goal-calculator`, {
            clientCode,
        })
    }
    return (
        <Button
            aria-label={data.label}
            sx={(theme: Theme) => ({
                border: `1px solid ${theme.palette.text.secondary}B2`,
                borderRadius: '10px',
                padding: '20px',
                minWidth: '250px',
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: theme.palette.primary[50],
                    border: `2px solid ${theme.palette.primary[100]}`,
                }
            })}
            onClick={goToGoalCalculator}
        >
            {data?.icon}
            <Typography variant='body_500' color='text.secondary' mt={1}>
                {data?.label}
            </Typography>
        </Button>
    )
}
